import { useEffect, useState } from "react";
import { CACHE_VERSION, cacheReady } from "@/registerSW";
import { BUILD_ID } from "@/version";

export default function StandbyScreen() {
  const [cached, setCached] = useState(false);
  useEffect(() => { cacheReady().then(setCached); }, []);
  return (
    <div className="standby" data-testid="standby-screen">
      <p className="diode-kicker">SPORE // BIO-SIGNAL TRANSLATOR v4.7</p>
      <h1 className="standby-title glow" data-testid="standby-title">
        LABORATORY TERMINAL — STANDBY
      </h1>
      <p className="standby-sub">
        awaiting experiment authorisation<span className="caret" />
      </p>
      <p className="standby-build" data-testid="standby-cache-version">
        build {BUILD_ID} · {cached ? `offline cache ready (${CACHE_VERSION})` : "caching…"}
      </p>
    </div>
  );
}
